import { injector } from '@asd-stan/injector/injector';

import { MeetingRepo } from '../api/meeting.repo';
import { MeetingService } from '../domain/meeting.service';

import { MEETING_REPO, MEETING_SERVICE } from './constants';

export const getMeetingRepo = () => injector.get<MeetingRepo>(MEETING_REPO);
export const getMeetingService = () => injector.get<MeetingService>(MEETING_SERVICE);
